export enum BookingStatusEnum {
  Upcoming = 'UPCOMING',
  Cancelled = 'CANCELLED',
  Past = 'PAST',
  Scheduled = 'SCHEDULED',
  Rescheduled = 'RESCHEDULED',
  All = 'ALL',
}
